import React from "react";
import styled from 'styled-components/macro';
import CardCandidate from "./Cards/CardCandidate";
import Grafica from "./Grafica/Grafica";
import { option as optionBarPartido } from '../components/Grafica/BarPartido'
import { useNomenclator } from "../contexts/nomenclatorContext";
import { rutas, responsive } from '../resources/constantes.json';
import { fmt } from '../utils';

const FilaBarPartido = ({ partido, horizontal }) => {
	const nomenclator = useNomenclator();
	const {codpar:codigoPartido,nombre:nombrePartido} = nomenclator.partidos[Number(partido.codpar) - 1]
	const logoSrc = `${rutas.logo}${codigoPartido.padStart(4, '0')}.webp`;
	return (
		<ContentPartido horizontal={horizontal}>
			<InfoContainer horizontal={horizontal}>
				<CardCandidate horizontal={horizontal} candidate={partido.cantotabla[0]} codpar={codigoPartido} type={'P'} />
				<CardCandidate horizontal={horizontal} candidate={partido.cantotabla[0]} codpar={codigoPartido} type={'V'} />
				<DataNumbers>
					<Votos><span>{partido.pvot}</span></Votos>
					<Votantes><span>{fmt(partido.vot)}</span></Votantes>
				</DataNumbers>
			</InfoContainer>
			<BarLogoContainer>
				<BarContainer horizontal={horizontal}>
					<Grafica
						option={optionBarPartido(partido, nomenclator, horizontal)}
						css={`
						height: ${horizontal ? '50px' : '280px'};
						display:flex;
						width:100%;
					`}
						animationDelay={500}
					/>
				</BarContainer>
				<div 
					css={`
						display:flex;
					`}
					title={nombrePartido}>
					<StyledLogo
						horizontal={horizontal}
						src={logoSrc}
					/>
				</div>
			</BarLogoContainer>
		</ContentPartido>
	)
}


const InfoContainer = styled.div`
	min-height: 200px;
	display:flex;
	flex-direction: ${({ horizontal }) => horizontal ? 'row' : 'column'};
	justify-content: space-between;
	gap: 10px;
	flex-wrap: wrap;
	@media
	screen and (max-width: 1365px) {
		min-height:unset;
		width:48%;
	}

	@media
	screen and (max-width: ${responsive.tablet}px) {
		width:100%;
		justify-content:space-between;
	}

`

const BarLogoContainer = styled.div`
	display:flex;
	align-items: center;
	flex-direction: column;
	width: 100%;
	gap: 5px;

	@media
	screen and (max-width: 1365px) {
		flex-direction: row;
		justify-content: space-between;
		width:48%;
		gap: 10px;
	}

	@media
	screen and (max-width: ${responsive.tablet}px) {
		width:100%;
	}
 
`

const BarContainer = styled.div`
	display:flex;
	width:100%;
	flex-direction: 'column';
	align-items:center;
	width:100%;

	@media
	screen and (max-width: 1365px) {
		flex-direction: 'row';
		width:70%;
	}
`

const Votos = styled.div`
	font-size: 24px;
	font-weight: 600;
`
const Votantes = styled.div`
	font-size: 16px;
	font-weight: 600;
`

const DataNumbers = styled.div`
	display: flex;
	text-align: center;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	@media
	screen and (max-width: 550px) {
		width:100%;
	}
`

const ContentPartido = styled.div`
	height:100%;
	min-width:150px;
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	flex-direction: ${({ horizontal }) => horizontal ? 'row' : 'column'};
	justify-content: center;
	${({ horizontal }) => horizontal && 'margin: 2rem 0;'};
	${({ horizontal }) => horizontal && `
		background: #FFFFFF;
		box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.05);
		border-radius: 3px;
		padding: 1rem;
	`};
`

const StyledLogo = styled.img`
  flex: 0 0 auto;
  max-width: 150px;
  background: grey;
  height:${({ horizontal }) => horizontal ? '100%' : '50px'};
  width:${({ horizontal }) => horizontal ? '100%' : '100%'};
`;

export default FilaBarPartido;